export default {
  activity: {
    include_activity_owner: true,
    include_activity_owner_image: true,
    include_activity_recipient: true,
  },
}
